import { render, staticRenderFns } from "./UsersListPage.vue?vue&type=template&id=4a23fbf9"
import script from "./users_view.js?vue&type=script&lang=js&external"
export * from "./users_view.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports